import React, { useContext } from 'react';
import Hero from '../Components/Hero/Hero';
import Offers from '../Components/Offers/Offers';
import { ShopContext } from '../Context/ShopContext';
import Item from '../Components/Item/Item';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './CSS/Shop.css'; 
import ShopStatusBanner from '../Components/ShopStatusBanner/ShopStatusBanner';
import InstagramCTA from '../Components/InstagramCTA/InstagramCTA.jsx';

const ItemSkeleton = () => {
    return (
        <SkeletonTheme baseColor="#f5d2b9ff" highlightColor="#fef5ee">
            <div className="item-card-skeleton">
                <Skeleton height="100%" style={{ aspectRatio: '1/1' }} />
                <div className="item-card-details-skeleton">
                    <Skeleton width="80%" />
                    <Skeleton width="40%" />
                </div>
            </div>
        </SkeletonTheme>
    );
};

const Shop = () => {
    const { all_products, loading, shopStatus } = useContext(ShopContext);
    const menuItems = all_products.filter(item => item.category === 'Menu');

    return (
        <div className="shop-page">
            <Hero />
            
            <ShopStatusBanner status={shopStatus} loading={loading}/>
            <Offers />

            <div id="menu-section" className="shop-layout container">
                <h2 className="shop-title">Our Menu</h2>
                
                <div className="product-grid">
                    {loading ? (
                        Array.from({ length: 8 }).map((_, index) => <ItemSkeleton key={index} />)
                    ) : (
                        menuItems.map((item) => <Item key={item._id} data={item} />)
                    )}
                </div>
            </div>
            <InstagramCTA />          
        </div>
    );
};

export default Shop;